
import * as CookieConsent from "vanilla-cookieconsent";

const title = window.cookieConsentStrings.title;
let body = window.cookieConsentStrings.content.join('<br><br>');

if (window.cookieConsentStrings.include_privacy_policy) {
    body += '<br>' + window.cookieConsentStrings.privacy_policy
}

function gtagConsentUpdate(cookie) {
    const acceptedCategories = cookie.categories

    if (typeof gtag !== 'undefined') {
        gtag('consent', 'update', {
            'analytics_storage': acceptedCategories.includes('analytics') ? 'granted' : 'denied',
            'ad_storage': acceptedCategories.includes('ads') ? 'granted' : 'denied',
            'ad_user_data': acceptedCategories.includes('ads') ? 'granted' : 'denied',
            'ad_personalization': acceptedCategories.includes('personalization') ? 'granted' : 'denied'
        });
    }
}

const config= {
    disablePageInteraction: window.location.href.indexOf('/personvern') === -1,
    guiOptions: {
        consentModal: {
            layout: 'box inline',
            position: 'bottom right',
        },
        preferencesModal: {
            layout: 'box',
        },
    },


    onFirstConsent: ({cookie}) => {
        gtagConsentUpdate(cookie);
    },

    onConsent: ({cookie}) => {
        gtagConsentUpdate(cookie);
    },

    onChange: ({cookie}) => {
        gtagConsentUpdate(cookie);
    },

    categories: {
        necessary: {
            readOnly: true,
            enabled: true,
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^(_ga|_gid)/,
                    },
                ],
            },
        },
        ads: {},
        personalization: {},
    },

    language: {
        default: 'default',

        translations: {
            default: {
                consentModal: {
                    title: title,
                    description: body,
                    acceptAllBtn: window.cookieConsentStrings.accept_all_btn_text,
                    showPreferencesBtn: window.cookieConsentStrings.read_more_btn_text,
                },
                preferencesModal: {
                    acceptAllBtn: window.cookieConsentStrings.accept_all_btn_text,
                    savePreferencesBtn: window.cookieConsentStrings.accept_selected_btn_text,
                    sections: [
                        {
                            title: window.cookieConsentStrings.required_cookies_title,
                            description: window.cookieConsentStrings.required_cookies_body,
                            linkedCategory: 'necessary',
                        },
                        {
                            title: window.cookieConsentStrings.marketing_title,
                            description: window.cookieConsentStrings.marketing_body,
                            linkedCategory: 'ads',
                        },
                        {
                            title: window.cookieConsentStrings.analytics_title,
                            description: window.cookieConsentStrings.analytics_body,
                            linkedCategory: 'analytics',
                        },
                        {
                            title: window.cookieConsentStrings.personalization_title,
                            description: window.cookieConsentStrings.personalization_body,
                            linkedCategory: 'personalization',
                        },
                        {
                            description: '<a class="cc-link" href="/personvern" target="_blank">' + window.cookieConsentStrings.about_privacy_text + '</a>',
                        }
                    ],
                },
            },
        },
    },
};

CookieConsent.run(config);